import { LOG_LEVELS } from 'src/app/@shared/services/log/log.service';


export const environment = {
  production: true,
  log_level: -1,
  here_map_api_key: 'v4V1lQyjYou-BAesiHAoh8zw704o8N_fTgFg66d4O8E',
  route_planning_service_url: 'https://api.bus.gov.il/prod/route-planner-prod/api/',
  rating_service_url: 'https://api.bus.gov.il/prod/route-planner-prod/api/',
  schedule_service_url: 'https://api.bus.gov.il/prod/mot-scheduler-prod/api/',
  calendar_service_url: 'https://api.bus.gov.il/prod/mot-scheduler-prod/api/',
  location_service_url: 'https://api.bus.gov.il/prod/route-planner-prod/api/',
  auto_complete_service_url: 'https://api.bus.gov.il/prod/route-planner-prod/api/',
  bo_be_service_url: 'https://api.bus.gov.il/prod/bo-be-prod/api/',
  website_url: 'https://bus.gov.il/',
  maslulan_url: 'https://route.bus.gov.il/',
  complaintUrl:
    'https://govforms.gov.il/mw/forms/PublicTransportRequest@mot.gov.il',
  complaintUrlMultiLanguage:
    'https://govforms.gov.il/mw/forms/PniotPublicTransport@mot.gov.il',
  publicReceptionUrl:
    'https://www.gov.il/he/government-service-branches/?officeId=c7db667a-4697-48af-a432-70f213c4e74e',
  surveyDelaySeconds: 5,
  map_center: { lat: 32.08088, lng: 34.78057, zoom: 13 },
  routePlannerDebugUi: false,
  isEmbedVideo: false,
  videoUrl: 'assets/videos/HARASHOT LETACHBURA TZIBOTIT _ ATAR HADASH - 16X9 (1).mp4',
  moreInfoUrl: 'https://www.rail.co.il/route-planner-info',
  isShowIntro: true,
};
